import { render, staticRenderFns } from "./campaign-view.vue?vue&type=template&id=2b615416&scoped=true"
import script from "./campaign-view.vue?vue&type=script&lang=js"
export * from "./campaign-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b615416",
  null
  
)

export default component.exports